var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 21,
    viewBox: "0 0 32 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo",
    clipPath: "url(#clip0_8064_10177)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M29.4586 0.5C30.6019 0.5 31.2558 1.26154 31.2558 2.5937V4.30427C31.2558 5.63558 30.6019 6.39454 29.4586 6.39454H23.4124C22.2691 6.39454 21.6152 5.63558 21.6152 4.30427V2.5937C21.6152 1.26154 22.2691 0.5 23.4124 0.5H29.4586Z",
    fill: "#7FA6CE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M18.818 0.5C19.9613 0.5 20.6152 1.26154 20.6152 2.5937V4.30427C20.6152 5.63558 19.9613 6.39454 18.818 6.39454H12.7718C11.6285 6.39454 10.9746 5.63558 10.9746 4.30427V2.5937C10.9746 1.26154 11.6285 0.5 12.7718 0.5H18.818Z",
    fill: "#4C54A0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M18.818 7.39453C19.9613 7.39453 20.6152 8.15607 20.6152 9.48823V11.1988C20.6152 12.5301 19.9613 13.2891 18.818 13.2891H12.7718C11.6285 13.2891 10.9746 12.5301 10.9746 11.1988V9.48823C10.9746 8.15607 11.6285 7.39453 12.7718 7.39453H18.818Z",
    fill: "#7FA6CE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M8.17723 0.5C9.32053 0.5 9.97442 1.26154 9.97442 2.5937V4.30427C9.97442 5.63558 9.32053 6.39454 8.17723 6.39454H2.13068C0.987387 6.39454 0.333496 5.63558 0.333496 4.30427V2.5937C0.333496 1.26154 0.987387 0.5 2.13068 0.5H8.17723Z",
    fill: "#7FA6CE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M8.17723 14.2904C9.32053 14.2904 9.97442 15.0502 9.97442 16.382V18.0917C9.97442 19.4234 9.32053 20.1832 8.17723 20.1832H2.13105C0.986649 20.1832 0.333496 19.4238 0.333496 18.0921V16.3824C0.333496 15.0507 0.986649 14.2908 2.13105 14.2908H8.17723V14.2904Z",
    fill: "#7FA6CE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M8.17723 7.39587C9.32053 7.39587 9.97442 8.15741 9.97442 9.48915V11.1989C9.97442 12.5289 9.32053 13.2904 8.17723 13.2904H2.13105C0.986649 13.2904 0.333496 12.5289 0.333496 11.1989V9.48915C0.333496 8.15741 0.986649 7.39587 2.13105 7.39587H8.17723Z",
    fill: "#4C54A0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8064_10177"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 20,
    fill: "white",
    transform: "translate(0.333496 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.6f808d334885dbe5ec918e871eb6d5b0.svg";
export { ForwardRef as ReactComponent };